import styled from 'styled-components'

const CobaltHyperlink = styled.div`
  color: #0070e0;
  font-size: 13px;
  cursor: pointer;

  &:hover {
    color: #0085ff;
  }
`

export default CobaltHyperlink



// WEBPACK FOOTER //
// ./src/components/typography/CobaltHyperlink.js